import { render, staticRenderFns } from "./DeathNoticeSequence.vue?vue&type=template&id=10fa715a&scoped=true&"
import script from "./DeathNoticeSequence.vue?vue&type=script&lang=js&"
export * from "./DeathNoticeSequence.vue?vue&type=script&lang=js&"
import style0 from "./DeathNoticeSequence.vue?vue&type=style&index=0&id=10fa715a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa715a",
  null
  
)

export default component.exports